module.exports = __webpack_public_path__ + "static/logo-dark-fa1af9fd46dbb5013e67ad96db9df23f.png";